import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _operatorLabelMap, _operatorCharacterMap, _componentOperatorMap;

import moment from 'moment';
export var Operator;

(function (Operator) {
  Operator["Lt"] = "LT";
  Operator["Le"] = "LE";
  Operator["Eq"] = "EQ";
  Operator["Ge"] = "GE";
  Operator["Gt"] = "GT";
  Operator["Sw"] = "SW";
  Operator["Ne"] = "NE";
})(Operator || (Operator = {}));

export var FilterDataTypes;

(function (FilterDataTypes) {
  FilterDataTypes["BIGINT"] = "BIGINT";
  FilterDataTypes["INTEGER"] = "INTEGER";
  FilterDataTypes["DECIMAL"] = "DECIMAL";
  FilterDataTypes["TIMESTAMP"] = "TIMESTAMP";
  FilterDataTypes["DATE"] = "DATE";
  FilterDataTypes["STRING"] = "STRING";
  FilterDataTypes["PICKLIST"] = "PICKLIST";
})(FilterDataTypes || (FilterDataTypes = {}));

export var operatorLabelMap = (_operatorLabelMap = {}, _defineProperty(_operatorLabelMap, Operator.Eq, 'Exact Match'), _defineProperty(_operatorLabelMap, Operator.Ne, 'Does Not Match'), _defineProperty(_operatorLabelMap, Operator.Lt, 'Less Than'), _defineProperty(_operatorLabelMap, Operator.Le, 'Less Than Or Equal'), _defineProperty(_operatorLabelMap, Operator.Gt, 'Greater Than'), _defineProperty(_operatorLabelMap, Operator.Ge, 'Greater Than Or Equal'), _defineProperty(_operatorLabelMap, Operator.Sw, 'Starts With'), _operatorLabelMap);
export var operatorCharacterMap = (_operatorCharacterMap = {}, _defineProperty(_operatorCharacterMap, Operator.Eq, '='), _defineProperty(_operatorCharacterMap, Operator.Ne, '<>'), _defineProperty(_operatorCharacterMap, Operator.Lt, '<'), _defineProperty(_operatorCharacterMap, Operator.Le, '<='), _defineProperty(_operatorCharacterMap, Operator.Gt, '>'), _defineProperty(_operatorCharacterMap, Operator.Ge, '>='), _defineProperty(_operatorCharacterMap, Operator.Sw, '~'), _operatorCharacterMap);
export var componentOperatorMap = (_componentOperatorMap = {}, _defineProperty(_componentOperatorMap, FilterDataTypes.STRING, [Operator.Eq, Operator.Ne, Operator.Sw]), _defineProperty(_componentOperatorMap, FilterDataTypes.DATE, [Operator.Eq, Operator.Ge, Operator.Le, Operator.Ne]), _defineProperty(_componentOperatorMap, FilterDataTypes.TIMESTAMP, [Operator.Eq, Operator.Ge, Operator.Le, Operator.Ne]), _defineProperty(_componentOperatorMap, FilterDataTypes.DECIMAL, [Operator.Eq, Operator.Ge, Operator.Gt, Operator.Lt, Operator.Ne]), _defineProperty(_componentOperatorMap, FilterDataTypes.BIGINT, [Operator.Eq, Operator.Ge, Operator.Gt, Operator.Lt]), _defineProperty(_componentOperatorMap, FilterDataTypes.PICKLIST, [Operator.Eq, Operator.Ne]), _componentOperatorMap);
/* Handling for TIMESTAMP */

export var validTimestampDatePickerOperators = function validTimestampDatePickerOperators(operator) {
  return [Operator.Ge, Operator.Le].includes(operator);
};
export var isTimestamp = function isTimestamp(type) {
  return FilterDataTypes.TIMESTAMP === type;
};
export var operatorMatchesDataType = function operatorMatchesDataType(field) {
  if (isTimestamp(field.type)) {
    return moment.isMoment(field.value) && [Operator.Ge, Operator.Le].includes(field.operator) || !moment.isMoment(field.value) && [Operator.Eq, Operator.Ne].includes(field.operator);
  }

  return true;
};
export var formatInitialValue = function formatInitialValue(type, operator, value) {
  if (isTimestamp(type) && validTimestampDatePickerOperators(operator)) {
    return moment(value);
  }

  return value || '';
};
export var formatValueForHawk = function formatValueForHawk(value, type) {
  if (moment.isMoment(value)) {
    return type === FilterDataTypes.DATE ? moment(value).format('YYYY-MM-DD') : moment(value).startOf('day').toJSON();
  } else {
    return value.trim();
  }
};
export var filterFromFields = function filterFromFields(fields) {
  var _Object$keys, _filter$conditions;

  var filter = {
    // TODO: Someday, with updated UX, this could be an OR
    relation: 'AND',
    conditions: (_Object$keys = Object.keys(fields)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.map(function (key) {
      var _fields$key;

      if (fields[key].value || ((_fields$key = fields[key]) === null || _fields$key === void 0 ? void 0 : _fields$key.length)) {
        return {
          operator: fields[key].operator,
          value: formatValueForHawk(fields[key].value, fields[key].type),
          field: key
        };
      }
    }).filter(Boolean)
  };
  return ((_filter$conditions = filter.conditions) === null || _filter$conditions === void 0 ? void 0 : _filter$conditions.length) ? filter : {};
};
export var filterToFields = function filterToFields(filterableFields, initialFilter) {
  return filterableFields.reduce(function (acc, curr) {
    var _initialFilter$condit, _componentOperatorMap2;

    var initialFilterMatch = initialFilter === null || initialFilter === void 0 ? void 0 : (_initialFilter$condit = initialFilter.conditions) === null || _initialFilter$condit === void 0 ? void 0 : _initialFilter$condit.find(function (condition) {
      return condition.field === curr.name;
    });
    var operator = (initialFilterMatch === null || initialFilterMatch === void 0 ? void 0 : initialFilterMatch.operator) || ((_componentOperatorMap2 = componentOperatorMap[curr.type]) === null || _componentOperatorMap2 === void 0 ? void 0 : _componentOperatorMap2[0]);
    acc[curr.name] = {
      operator: operator,
      value: formatInitialValue(curr.type, operator, initialFilterMatch === null || initialFilterMatch === void 0 ? void 0 : initialFilterMatch.value),
      label: curr.label,
      type: curr.type
    };
    return acc;
  }, {});
};

try {
  validTimestampDatePickerOperators.__docgenInfo = {
    description: '',
    displayName: 'validTimestampDatePickerOperators',
    methods: [],
    props: {}
  };
} catch (e) {}

try {
  isTimestamp.__docgenInfo = {
    description: '',
    displayName: 'isTimestamp',
    methods: [],
    props: {}
  };
} catch (e) {}

try {
  operatorMatchesDataType.__docgenInfo = {
    description: '',
    displayName: 'operatorMatchesDataType',
    methods: [],
    props: {}
  };
} catch (e) {}

try {
  filterFromFields.__docgenInfo = {
    description: '',
    displayName: 'filterFromFields',
    methods: [],
    props: {}
  };
} catch (e) {}
//# sourceMappingURL=utils.js.map